/*global define*/

define(function (require) {
    'use strict';

    var paginationView = require('./maDatagridPagination.html'),
        DatagridPaginationController = require('./maDatagridPaginationController');

    function DatagridPaginationDirective() {
        return {
            restrict: 'E',
            scope: {
                page: '@',
                perPage: '@',
                totalItems: '@',
                setPage: '&'
            },
            template: paginationView,
            controllerAs: 'paginationCtrl',
            controller: DatagridPaginationController
        };
    }

    DatagridPaginationDirective.$inject = [];

    return DatagridPaginationDirective;
});



/** WEBPACK FOOTER **
 ** ./~/ng-annotate-loader/loader.js!./src/javascripts/ng-admin/Crud/list/maDatagridPagination.js
 **/